import { render, staticRenderFns } from "./teacherinfo.vue?vue&type=template&id=43aed2e8&scoped=true"
import script from "./teacherinfo.vue?vue&type=script&lang=js"
export * from "./teacherinfo.vue?vue&type=script&lang=js"
import style0 from "./teacherinfo.vue?vue&type=style&index=0&id=43aed2e8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aed2e8",
  null
  
)

export default component.exports